<!--div class="row">
  <div class="col">
    <div class="alert alert-warning" role="alert">
      <b>Important Notice:</b> From September 2023 all {{ utils.getAppName() }} users will need to have a unique email in order to sign in.
      If you are currently using a shared email please update it in <a routerLink="/user/details">your profile</a> before September 2023.
      For more information visit the <a [href]="utils.getUrgentNoticeUrl()" target="_blank">{{ utils.getAppName() }} Help Centre</a>.
    </div>
  </div>
</div-->

<div class="row" appMarginTop *ngIf="app.userAccountLink.permissions == 'Employee'">
  <div class="col-12">
    <div class="alert alert-info" role="alert">
      Thank you for using {{ utils.getAppName() }}. You are viewing the {{ utils.getAppName() }} web portal (for administrative use only). Please close the web portal and open the {{ utils.getAppName() }} mobile app for {{ utils.getLangTerm('parent-child-sites-combined.singular', 'Site').toLowerCase() }} access. Download and install <b><a [href]="utils.getAndroidMobileAppStoreUrl()" target="_blank">{{ utils.getAppName() }} for Android</a></b> or <b><a [href]="utils.getIosMobileAppStoreUrl()" target="_blank">{{ utils.getAppName() }} for iOS</a></b>.
    </div>
  </div>
</div>

<div class="row" appMarginTop>
  <div class="col">
    <button
      mat-raised-button
      color="secondary"
      (click)="onSelectSites()"
      [matBadge]="'' + (app.chart_selected_sites.length ? app.chart_selected_sites.length : 'All')"
      class="m-1 mr-2"
      matTooltip="Filter all results by the selected {{ utils.getLangTerm('parent-child-sites-combined.plural', 'Sites').toLowerCase() }}"
      style="float: left;">
      <mat-icon>domain</mat-icon> Select {{ utils.getLangTerm('parent-child-sites-combined.plural', 'Sites') }}
    </button>

    <input
      type="text"
      placeholder="Select Date Range"
      [(ngModel)]="app.filter_date_range"
      name="filter_date_range"
      class="form-control m-1 mr-2"
      style="min-width: 220px"
      bsDaterangepicker
      [appForceReadonly]="true"
      [bsConfig]="datepickerConfig"
      matTooltip="Filter all results within the selected date range" />

    <button mat-raised-button class="m-1 mr-2" color="secondary" (click)="refreshStats()"
      matTooltip="Refresh the results" style="float: left;">
      <mat-icon>refresh</mat-icon> Refresh
    </button>
  </div>
</div>

<div class="row" appMarginTop>
  <div class="col">
    <mat-card appearance="outlined">
      <mat-card-content>
        <h5>All {{ utils.getLangTerm('parent-child-sites-combined.singular', 'Site') }} Activities</h5>
        <div>
          <canvas style="height: 250px !important;" id="site_activities_chart_ref">{{ site_activities_chart }}</canvas>
        </div>
      </mat-card-content>
      <mat-card-actions class="d-flex flex-wrap">
          <button
            mat-raised-button
            class="m-1 mr-2"
            color="secondary"
            [routerLink]="['/', 'reports', 'access-records']"
            matTooltip="Go to the 'Sign In/Out Records' page">
            Sign In/Out Records
          </button>

          <button
            mat-raised-button
            class="m-1 mr-2"
            color="secondary"
            [routerLink]="['/', 'reports', 'onsite-records']"
            matTooltip="Go to the 'Currently Onsite Records' page">
            Currently Onsite Records
          </button>

          <button
            mat-raised-button
            class="m-1 mr-2"
            color="secondary"
            [routerLink]="['/', 'reports', 'time-onsite-records']"
            matTooltip="Go to the 'Time Spent Onsite' page">
            Time Spent Onsite Records
          </button>
      </mat-card-actions>
    </mat-card>

    <mat-card appearance="outlined">
      <mat-card-content>
        <h5>Hazards & Risks</h5>
        <div>
          <canvas style="height: 250px !important;" id="hazards_chart_ref">{{ hazards_chart }}</canvas>
        </div>
      </mat-card-content>
      <mat-card-actions class="d-flex flex-wrap">
        <button
          mat-raised-button
          class="m-1 mr-2"
          color="secondary"
          [routerLink]="['/', 'hazards']"
          matTooltip="Go to the 'Hazard & Risk Templates' page">
          Hazard & Risk Templates
        </button>
      </mat-card-actions>
    </mat-card>

    <mat-card appearance="outlined">
      <mat-card-content>
        <h5>Your Connected Network</h5>
        <div>
          <canvas id="users_chart_ref">{{ users_chart }}</canvas>
        </div>
      </mat-card-content>
      <mat-card-actions class="d-flex flex-wrap">
          <button
            mat-raised-button
            class="m-1 mr-2"
            color="secondary"
            [routerLink]="['/', 'contractors']"
            matTooltip="Go to the '{{ utils.getLangTerm('contractors.plural', 'Contractors') }}' page">
            {{ utils.getLangTerm('contractors.plural', 'Contractors') }}
          </button>

          <button
            mat-raised-button
            class="m-1 mr-2"
            color="secondary"
            [routerLink]="['/', 'employees']"
            matTooltip="Go to the '{{ utils.getLangTerm('employees.plural', 'Employees') }}'">
            {{ utils.getLangTerm('employees.plural', 'Employees') }}
          </button>
      </mat-card-actions>
    </mat-card>
  </div>

  <div class="col">
    <mat-card appearance="outlined">
      <mat-card-content>
        <h5>Release Summary</h5>
        <ul>
          <li><b>Create Custom Notifications:</b> You can now set up notification roles to manage alerts your way.</li>
          <li><b>Personalized Dashboards:</b> Customize your dashboard and explore charts for various features.</li>
          <li><b>Enhanced Performance and Security:</b> We've upgraded our system to improve speed and strengthen security.</li>
          <li>Please visit the <a [href]="utils.getKnowledgebaseUrl()" target="_blank" matTooltip="Open the Help Centre to learn more.">Help Centre</a> for more information.</li>
        </ul>

        <div class="alert alert-info" role="alert">
          Thank you for using {{ utils.getAppName() }}. You are viewing the {{ utils.getAppName() }} web portal (for administrative use only). The {{ utils.getAppName() }} mobile app can be downloaded from the <b><a [href]="utils.getAndroidMobileAppStoreUrl()" target="_blank">Google Play Store for Android</a></b> or <b><a [href]="utils.getIosMobileAppStoreUrl()" target="_blank">App Store for iOS</a></b>.
        </div>
      </mat-card-content>
      <mat-card-actions></mat-card-actions>
    </mat-card>

    <mat-card appearance="outlined">
      <mat-card-content>
        <h5>Incidents & Near Misses</h5>
        <div>
          <canvas style="height: 250px !important;" id="incidents_chart_ref">{{ incidents_chart }}</canvas>
        </div>
      </mat-card-content>
      <mat-card-actions class="d-flex flex-wrap">
        <button
          mat-raised-button
          class="m-1 mr-2"
          color="secondary"
          [routerLink]="['/', 'incidents']"
          matTooltip="Go to the 'Incident & Near Miss Register' page">
          Incident & Near Miss Register
        </button>
      </mat-card-actions>
    </mat-card>
  </div>
</div>
